import React from 'react';
// import { useRouter } from 'next/router';
import { useTheme } from 'contexts/theme';
import { Menu as AntMenu, Drawer, Button } from 'antd';
import { useState } from 'react';
import {
  FileDoneOutlined,
  DollarOutlined,
  FundOutlined,
  MenuOutlined,
  UploadOutlined,
  UserOutlined,
  EnvironmentOutlined,
  ToolOutlined,
  MailOutlined,
  FileOutlined,
  CheckCircleOutlined,
  RiseOutlined,
  FileSearchOutlined,
  TrophyOutlined
} from '@ant-design/icons';

import styles from './menu.module.sass';
import { useNavigate } from 'react-router-dom';
import AccessControl from 'components/AccessControl';
import isAllowedTo from 'utils/isAllowedTo';

const { Item, SubMenu } = AntMenu;

export default function Menu() {
  const navigate = useNavigate();
  //   const router = useRouter();
  const [visible, setVisible] = useState(false);
  const { dark } = useTheme();

  function handleClick(item: any) {
    navigate(item.key);
  }

  return (
    <>
      <Button
        className={styles['menu-btn']}
        type="primary"
        icon={<MenuOutlined />}
        onClick={() => setVisible(true)}
      />
      <Drawer
        className={dark ? styles['drawer-dark'] : styles.drawer}
        width={250}
        visible={visible}
        onClose={() => setVisible(false)}
        placement="left"
      >
        <AntMenu onClick={handleClick}>
          <Item key="/dashboard" icon={<FundOutlined />}>
            Dashboard
          </Item>
          <AccessControl permissions={['SamDashboard_Read']}>
          <Item key="/samdashboard" icon={<FundOutlined />}>
            SamDashboard
          </Item>
          </AccessControl>
          <AccessControl permissions={['Expense_Read']}>
          <Item key="/expense" icon={<DollarOutlined />}>
            Expense
          </Item>
          </AccessControl>
          {isAllowedTo(['Budget_Read', 'Budget_Write']) && (
            <Item key="/budget" icon={<RiseOutlined />}>
              Budget
            </Item>
          )}
           {isAllowedTo(['Master_Read']) && (
          <Item key="/deals" icon={<TrophyOutlined />}>
            Deals
          </Item>
           )}
          {isAllowedTo(['Reports_Read', 'Reports_Write','Reports_MonthEndMaster','Admin_Privilege','Reports_MonthEndMasterForFluke','Reports_MfgTotals']) && (
          <Item key="/reports" icon={<FileDoneOutlined />}>
            Reports
          </Item>
          )}
          {isAllowedTo(['ZipRep_Read', 'ZipRep_Write']) && (
          <Item key="/zips" icon={<MailOutlined />}>
            Zip Codes
          </Item>
          )}
          {isAllowedTo(['Master_Read']) && (
          <Item key="/users" icon={<UserOutlined />}>
            Users
          </Item>
          )}
          <AccessControl permissions={['UploadData_Read']}>
            <AntMenu onClick={handleClick}>
              <Item key="/uploads" icon={<UploadOutlined />}>
                Uploads
              </Item>
            </AntMenu>
          </AccessControl>
          
          <AccessControl permissions={['HeatMap_Read']}>
          <Item key="/map" icon={<EnvironmentOutlined />}>
            Map
          </Item>
          </AccessControl>
          {isAllowedTo(['Master_Read']) && (
          <Item key="/verifications" icon={<CheckCircleOutlined />}>
            Verifications
          </Item>
          )}
          {isAllowedTo(['Master_Read']) && (
          <Item key="/nav-lookup" icon={<FileSearchOutlined />}>
            MFG Lookup
          </Item>
          )}
          {isAllowedTo(['Master_Read']) && (
          <Item key="/scheduler" icon={<FundOutlined />}>
            Scheduler
          </Item>
          )}
          <AccessControl permissions={['Master_Read']}>
            <SubMenu key="master" icon={<FileOutlined />} title="Master">
              <Item key="/master/plant-mapper">Plant Mapper</Item>
              <Item key="/master/region-mapper">Region Mapper</Item>
              <Item key="/master/privileges">Privilege Screen</Item>
              <Item key="/master/manufactures">Manufactures</Item>
              <Item key="/master/distributors">Distributors</Item>
              <Item key="/master/goal-settings">Goal Settings</Item>
              <Item key="/master/dist-rep-mapper">Dist Rep Mapper</Item>
              <Item key="/master/product-family-management">
                Product Family Management
              </Item>
              <Item key="/master/hq-filter">Hq Filter</Item>
              <Item key="/master/territory-code-mapper">
                Territory Code Mapper
              </Item>
              <Item key="/master/dist-mfg-filter">Dist Mfg Filter</Item>
              <Item key="/master/end-user-table">End User Table</Item>
            </SubMenu>
          </AccessControl>
          {/*
            
            <Item key="expense" icon={<FileDoneOutlined />}>
                Budget
            </Item>
            
            
             */}
        </AntMenu>
      </Drawer>
    </>
  );
}
